<template>
  <div class="warehouse-shell">

    <!-- ── NAV ── -->
    <div class="wh-nav">
      <div class="wh-nav-group">
        <button class="wh-tab" :class="{ active: isStockActive }" type="button" @click="openStock">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-4 0v2M8 7V5a2 2 0 0 0-4 0v2"/></svg>
          Estoque
        </button>
        <button class="wh-tab" :class="{ active: isRequestsActive }" type="button" @click="openRequests">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          Solicitações
        </button>
        <button class="wh-tab" :class="{ active: isPlanejamentoActive }" type="button" @click="openPlanejamento">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
          Planejamento
        </button>
        <button class="wh-tab" :class="{ active: isDamagesActive }" type="button" @click="openDamages">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          Avarias
        </button>
      </div>
      <div v-if="!isAnalyst" class="wh-nav-actions">
        <button class="wh-action-btn" :class="{ active: isProvideActive }" type="button" @click="openProvideForm">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          Fornecer
        </button>
        <button class="wh-action-btn" :class="{ active: isAddItemActive }" type="button" @click="() => openAddItemForm()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Adicionar
        </button>
        <button class="wh-action-btn" :class="{ active: isTransferItemActive }" type="button" @click="openTransferItemForm">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
          Transferir
        </button>
        <button class="wh-action-btn" :class="{ active: mode === 'nfe-import' }" type="button" @click="openNfeImport">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
          Importar NF
        </button>
      </div>
    </div>

    <WarehouseNFeImportForm v-if="mode === 'nfe-import'" @cancel="openStock" @done="onNfeImportDone" />
    <WarehouseProvideEquipmentForm v-else-if="mode === 'provide'" />
    <WarehouseAddItemForm v-else-if="mode === 'add-item'" />
    <WarehouseTransferItemForm v-else-if="mode === 'transfer-item'" />
    <WarehouseDamageReportForm v-else-if="mode === 'damage-form'" />
    <WarehouseDamageDetailView v-else-if="mode === 'damage-detail'" :can-resolve="canResolveDamage" />

    <section v-else-if="mode === 'damages'" class="section">
      <div class="section-head">
        <h2 class="section-title">Avarias</h2>
        <button class="toggle-btn" type="button" @click="showResolvedHistory = !showResolvedHistory">
          {{ showResolvedHistory ? 'Ver pendentes' : 'Ver histórico' }}
        </button>
      </div>
      <div v-if="filteredDamages.length === 0" class="empty-hint">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        Nenhuma avaria para esta visão.
      </div>
      <div v-else class="cards-grid">
        <article v-for="entry in filteredDamages" :key="entry.id" class="item-card damage-clickable" @click="openDamageDetail(entry.id)">
          <div class="card-photo">
            <img v-if="itemPhotoById(entry.toolItemId)" class="card-img" :src="itemPhotoById(entry.toolItemId)" alt="foto item" />
            <div v-else class="card-img-placeholder">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
          </div>
          <div class="card-body">
            <div class="card-title">{{ itemName(entry.toolItemId) }}</div>
            <div class="card-meta">{{ entry.damageSummary || entry.title || '-' }}</div>
            <span class="status-chip" :class="entry.status === 'resolvido' ? 'chip--ok' : 'chip--warn'">
              {{ entry.status }}
            </span>
          </div>
        </article>
      </div>
    </section>

    <section v-else-if="tab === 'estoque'" class="section">
      <WarehouseDashboardWidget />
      <div class="section-head">
        <h2 class="section-title">Estoque</h2>
        <label class="toggle-check">
          <input v-model="organizeByArea" type="checkbox" />
          Por área
        </label>
      </div>

      <div v-if="items.length === 0" class="empty-hint">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-4 0v2M8 7V5a2 2 0 0 0-4 0v2"/></svg>
        Nenhum item no estoque.
      </div>

      <!-- grouped by area -->
      <template v-else-if="organizeByArea">
        <section v-for="group in groupedItemsByArea" :key="group.id" class="area-section">
          <h3 class="area-title">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            {{ group.name }}
            <span class="area-count">{{ group.items.length }}</span>
          </h3>
          <div v-if="group.items.length === 0" class="empty-hint-sm">Sem itens nesta área.</div>
          <div v-else class="cards-grid">
            <article v-for="item in group.items" :key="item.id" class="item-card">
              <div class="card-photo">
                <img v-if="item.photoDataUrl" class="card-img" :src="$resolveUrl(item.photoDataUrl)" alt="foto item" />
                <div v-else class="card-img-placeholder">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                </div>
              </div>
              <div class="card-body">
                <div class="card-title">{{ item.name }}</div>
                <div class="card-meta">{{ item.category }} · {{ item.code }}</div>
                <div class="qty-row">
                  <span class="qty-badge" :class="item.availableQuantity <= item.quantityMin ? 'qty--low' : 'qty--ok'">
                    {{ item.availableQuantity }} disp.
                  </span>
                  <span class="qty-badge qty--total">{{ item.quantityTotal }} total</span>
                  <span v-if="item.conditionStatus" class="qty-badge qty--cond">{{ item.conditionStatus }}</span>
                </div>
              </div>
              <div class="card-footer">
                <button class="card-btn" type="button" @click="viewItem(item.id)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                  Info
                </button>
                <button class="card-btn" type="button" @click="openMovementHistory(item.id, item.name)">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z" opacity="0"/><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="9"/></svg>
                  Histórico
                </button>
                <template v-if="!isAnalyst">
                  <button class="card-btn" type="button" @click="openAddItemForm(item.id)">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                    Editar
                  </button>
                  <button class="card-btn card-btn--warn" type="button" @click="reportDamage(item.id)">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>
                    Avaria
                  </button>
                  <button class="card-btn" type="button" @click="openTransferArea(item.id, item.location)">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/></svg>
                    Área
                  </button>
                </template>
              </div>
              <div v-if="transferAreaItemId === item.id && !isAnalyst" class="transfer-inline">
                <select class="transfer-select" v-model="transferAreaProjectId">
                  <option value="">Sem área</option>
                  <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
                </select>
                <div class="transfer-actions">
                  <button class="btn-save-sm" type="button" @click="confirmTransferArea(item.id)">Confirmar</button>
                  <button class="btn-cancel-sm" type="button" @click="cancelTransferArea">Cancelar</button>
                </div>
              </div>
            </article>
          </div>
        </section>
      </template>

      <!-- flat list -->
      <div v-else class="cards-grid">
        <article v-for="item in items" :key="item.id" class="item-card">
          <div class="card-photo">
            <img v-if="item.photoDataUrl" class="card-img" :src="$resolveUrl(item.photoDataUrl)" alt="foto item" />
            <div v-else class="card-img-placeholder">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
          </div>
          <div class="card-body">
            <div class="card-title">{{ item.name }}</div>
            <div class="card-meta">{{ item.category }} · {{ item.code }}</div>
            <div class="card-meta">{{ areaLabel(item.location) }}</div>
            <div class="qty-row">
              <span class="qty-badge" :class="item.availableQuantity <= item.quantityMin ? 'qty--low' : 'qty--ok'">
                {{ item.availableQuantity }} disp.
              </span>
              <span class="qty-badge qty--total">{{ item.quantityTotal }} total</span>
              <span v-if="item.conditionStatus" class="qty-badge qty--cond">{{ item.conditionStatus }}</span>
            </div>
          </div>
          <div class="card-footer">
            <button class="card-btn" type="button" @click="viewItem(item.id)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
              Info
            </button>
            <button class="card-btn" type="button" @click="openMovementHistory(item.id, item.name)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="9"/></svg>
              Histórico
            </button>
            <template v-if="!isAnalyst">
              <button class="card-btn" type="button" @click="openAddItemForm(item.id)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                Editar
              </button>
              <button class="card-btn card-btn--warn" type="button" @click="reportDamage(item.id)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/></svg>
                Avaria
              </button>
              <button class="card-btn" type="button" @click="openTransferArea(item.id, item.location)">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/></svg>
                Área
              </button>
            </template>
          </div>
          <div v-if="transferAreaItemId === item.id && !isAnalyst" class="transfer-inline">
            <select class="transfer-select" v-model="transferAreaProjectId">
              <option value="">Sem área</option>
              <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
            </select>
            <div class="transfer-actions">
              <button class="btn-save-sm" type="button" @click="confirmTransferArea(item.id)">Confirmar</button>
              <button class="btn-cancel-sm" type="button" @click="cancelTransferArea">Cancelar</button>
            </div>
          </div>
        </article>
      </div>
    </section>

    <section v-else-if="tab === 'solicitacoes'" class="section">

      <!-- Requisições do planejamento -->
      <div class="sub-block">
        <h3 class="sub-title">Requisições do planejamento</h3>
        <div v-if="toolRequests.length === 0" class="empty-hint-sm">Sem requisições pendentes.</div>
        <div v-else class="req-list">
          <div v-for="entry in toolRequests" :key="entry.id" class="req-card">
            <div class="req-info">
              <div class="req-name">{{ entry.itemName }}</div>
              <div class="req-meta">Tarefa: {{ entry.taskTitle }} · Qty: {{ entry.quantity }}</div>
              <span class="status-chip chip--pending">{{ entry.status }}</span>
            </div>
            <div v-if="!isAnalyst" class="req-actions">
              <button class="req-btn req-btn--ok" type="button" @click="respondToolRequest(entry.id, 'aprovado')">Aprovar</button>
              <button class="req-btn req-btn--deny" type="button" @click="respondToolRequest(entry.id, 'reprovado')">Reprovar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reservas por tarefa -->
      <div class="sub-block">
        <h3 class="sub-title">Reservas por tarefa</h3>
        <div v-if="reservations.length === 0" class="empty-hint-sm">Sem reservas.</div>
        <div v-else class="req-list">
          <div v-for="entry in reservations" :key="entry.id" class="req-card">
            <div class="req-info">
              <div class="req-name">{{ itemName(entry.itemId) }}</div>
              <div class="req-meta">{{ entry.reserveStartDate }} → {{ entry.reserveEndDate }} · Qty: {{ entry.quantity }}</div>
              <span class="status-chip chip--info">{{ entry.status }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Solicitações de colaboradores -->
      <div class="sub-block">
        <h3 class="sub-title">Solicitações de colaboradores</h3>
        <div v-if="userRequests.length === 0" class="empty-hint-sm">Sem solicitações.</div>
        <div v-else class="req-list">
          <div v-for="entry in userRequests" :key="entry.id" class="req-card">
            <div class="req-info">
              <div class="req-name">{{ itemName(entry.itemId) }}</div>
              <div class="req-meta">{{ entry.requesterUsername }} · Qty: {{ entry.quantity }}</div>
              <div v-if="entry.notes" class="req-meta req-notes">{{ entry.notes }}</div>
              <span class="status-chip" :class="entry.status === 3 ? 'chip--ok' : entry.status === 0 ? 'chip--pending' : 'chip--info'">
                {{ requestStatusLabel(entry.status) }}
              </span>
            </div>
            <div v-if="!isAnalyst" class="req-actions">
              <button v-if="entry.status === 0" class="req-btn req-btn--ok" type="button" @click="setUserRequestStatus(entry.id, 1)">Aprovar</button>
              <button v-if="entry.status === 1" class="req-btn req-btn--ok" type="button" @click="setUserRequestStatus(entry.id, 2)">Fornecido</button>
              <button v-if="entry.status === 3" class="req-btn" type="button" @click="requestUserReturn(entry.id)">Solicitar devolução</button>
              <button v-if="entry.status === 4" class="req-btn req-btn--ok" type="button" @click="setUserRequestStatus(entry.id, 5)">Devolvido</button>
            </div>
          </div>
        </div>
      </div>

    </section>

    <section v-else-if="tab === 'planejamento'" class="section">
      <div class="section-head">
        <h2 class="section-title">Planejamento de ferramentas</h2>
      </div>
      <div v-if="isLoadingReservations" class="empty-hint">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="animation:spin 1s linear infinite"><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" opacity=".25"/><path d="M21 12a9 9 0 0 0-9-9"/></svg>
        Carregando…
      </div>
      <div v-else-if="Object.keys(reservationsByDate).length === 0" class="empty-hint">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
        Nenhuma ferramenta reservada.
      </div>
      <div v-else class="reservations-timeline">
        <div v-for="(tools, dateKey) in reservationsByDate" :key="dateKey" class="timeline-entry">
          <div class="timeline-date">{{ formatDate(dateKey) }}</div>
          <div class="timeline-tools">
            <div v-for="(tool, idx) in tools" :key="`${dateKey}-${idx}`" class="tool-reservation">
              <div class="tool-name">{{ tool.toolName }}</div>
              <div class="tool-qty">{{ tool.quantity }}×</div>
              <div class="tool-task">{{ tool.taskTitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <WarehouseMovementHistoryModal
      v-if="movementHistoryItemId"
      :item-id="movementHistoryItemId"
      :item-name="movementHistoryItemName"
      @close="closeMovementHistory"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { apiFetch } from '@/store/api'
import { uiStore } from '@/store/ui'
import { projectsStore } from '@/store/projects'
import { rolesStore } from '@/store/roles'
import { sessionStore } from '@/store/session'
import { warehouseStore, type WarehouseItem } from '@/store/warehouse'
import WarehouseProvideEquipmentForm from '@/components/warehouse/WarehouseProvideEquipmentForm.vue'
import WarehouseAddItemForm from '@/components/warehouse/WarehouseAddItemForm.vue'
import WarehouseTransferItemForm from '@/components/warehouse/WarehouseTransferItemForm.vue'
import WarehouseDamageReportForm from '@/components/warehouse/WarehouseDamageReportForm.vue'
import WarehouseDamageDetailView from '@/components/warehouse/WarehouseDamageDetailView.vue'
import WarehouseNFeImportForm from '@/components/warehouse/WarehouseNFeImportForm.vue'
import WarehouseDashboardWidget from '@/components/warehouse/WarehouseDashboardWidget.vue'
import WarehouseMovementHistoryModal from '@/components/warehouse/WarehouseMovementHistoryModal.vue'

interface ReservationRow {
  id: string
  itemId: string
  projectId: string
  taskId: string
  quantity: number
  reserveStartDate: string
  reserveEndDate: string
  status: string
}

interface DamageRow {
  id: string
  title: string
  description: string
  priority: string
  status: string
  toolItemId: string
  damageSummary: string
  damageDetails: string
  collaboratorUsername: string
  photoDataUrls: string[]
}

interface UserRequestRow {
  id: string
  itemId: string
  requesterUsername: string
  projectId: string
  quantity: number
  status: number
  notes: string
  createdAt: string
  updatedAt: string
}

export default defineComponent({
  name: 'WarehouseView',
  components: {
    WarehouseProvideEquipmentForm,
    WarehouseAddItemForm,
    WarehouseTransferItemForm,
    WarehouseDamageReportForm,
    WarehouseDamageDetailView,
    WarehouseNFeImportForm,
    WarehouseDashboardWidget,
    WarehouseMovementHistoryModal
  },
  props: {
    isAnalyst: { type: Boolean, default: false }
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const tab = ref<'estoque' | 'solicitacoes' | 'planejamento'>('estoque')
    const reservations = ref<ReservationRow[]>([])
    const damages = ref<DamageRow[]>([])
    const userRequests = ref<UserRequestRow[]>([])
    const toolRequests = ref<Array<{ id: string; taskId: string; itemId: string; quantity: number; status: string; taskTitle?: string; itemName?: string }>>([])
    const transferAreaItemId = ref('')
    const transferAreaProjectId = ref('')
    const showFilterPanel = ref(false)
    const organizeByArea = ref(false)
    const showResolvedHistory = ref(false)
    const reservationsByDate = ref<Record<string, Array<{ toolId: string; toolName: string; quantity: number; taskId: string; taskTitle: string; startDate: string; endDate: string }>>>({})
    const isLoadingReservations = ref(false)

    const items = computed(() => warehouseStore.all())
    const projects = computed(() => projectsStore.all())

    const mode = computed<'browse' | 'provide' | 'add-item' | 'damages' | 'transfer-item' | 'damage-form' | 'damage-detail' | 'nfe-import'>(() => {
      if (route.path.startsWith('/almoxarifado/importar-nf')) return 'nfe-import'
      if (route.path.startsWith('/almoxarifado/fornecer')) return 'provide'
      if (route.path.startsWith('/almoxarifado/adicionar-item')) return 'add-item'
      if (route.path.startsWith('/almoxarifado/avarias/nova')) return 'damage-form'
      if (route.path.startsWith('/almoxarifado/avarias/detalhe/')) return 'damage-detail'
      if (route.path.startsWith('/almoxarifado/avarias')) return 'damages'
      if (route.path.startsWith('/almoxarifado/transferir-item')) return 'transfer-item'
      return 'browse'
    })

    const movementHistoryItemId = ref('')
    const movementHistoryItemName = ref('')

    const openMovementHistory = (itemId: string, name: string) => {
      movementHistoryItemId.value = itemId
      movementHistoryItemName.value = name
    }
    const closeMovementHistory = () => {
      movementHistoryItemId.value = ''
      movementHistoryItemName.value = ''
    }

    const openNfeImport = () => {
      router.push('/almoxarifado/importar-nf')
    }

    const onNfeImportDone = async () => {
      tab.value = 'estoque'
      router.push('/almoxarifado?tab=estoque')
      await refreshAll()
    }
    const canResolveDamage = computed(() => {
      const user = sessionStore.state.user
      if (!user) return false
      if (user.role === 'admin-master' || user.role === 'admin-obra') return true
      const role = rolesStore.all().find((entry) => entry.id === user.roleId)
      return Number(role?.warehouseAccess || 0) >= 2
    })

    const findProjectByLocation = (location: string) => {
      const normalized = location.trim().toLowerCase()
      if (!normalized) return null
      return (
        projects.value.find((project) => project.id.toLowerCase() === normalized) ||
        projects.value.find((project) => project.name.trim().toLowerCase() === normalized) ||
        null
      )
    }

    const areaLabel = (location: string) => {
      if (!location.trim()) return 'Sem area'
      const project = findProjectByLocation(location)
      return project ? project.name : location
    }

    const supervisorLabel = (location: string) => {
      const project = findProjectByLocation(location)
      if (!project) return '-'
      if (project.responsibleNames.length > 0) return project.responsibleNames.join(', ')
      return project.ownerName || project.ownerUsername || '-'
    }

    const isItemInProject = (item: WarehouseItem, projectId: string) => {
      const project = projects.value.find((entry) => entry.id === projectId)
      if (!project) return false
      const itemLoc = item.location.trim().toLowerCase()
      if (!itemLoc) return false
      return itemLoc === project.id.trim().toLowerCase() || itemLoc === project.name.trim().toLowerCase()
    }

    const groupedItemsByArea = computed(() => {
      const projectGroups = projects.value.map((project) => ({
        id: project.id,
        name: project.name,
        items: items.value.filter((item) => isItemInProject(item, project.id))
      }))
      const noAreaItems = items.value.filter((item) => !projects.value.some((project) => isItemInProject(item, project.id)))
      return [...projectGroups, { id: 'sem-area', name: 'Sem area', items: noAreaItems }]
    })

    const filteredDamages = computed(() => {
      return damages.value.filter((entry) => {
        const resolved = entry.status === 'resolvido'
        return showResolvedHistory.value ? resolved : !resolved
      })
    })

    const refreshReservations = async () => {
      reservations.value = await apiFetch<ReservationRow[]>('/warehouse/reservations')
    }

    const refreshDamages = async () => {
      damages.value = await apiFetch<DamageRow[]>('/tickets?category=manutencao-ferramentas')
    }
    const refreshUserRequests = async () => {
      userRequests.value = await apiFetch<UserRequestRow[]>('/warehouse/user-requests?includeReturned=1')
    }

    const refreshToolRequests = async () => {
      try {
        const requests = await apiFetch<Array<{ id: string; taskId: string; itemId: string; quantity: number; status: string }>>('/warehouse/task-tool-requests?status=pendente')
        const items = warehouseStore.all()
        toolRequests.value = (requests || []).map(req => {
          const item = items.find((i) => i.id === req.itemId)
          return {
            ...req,
            taskTitle: req.taskId,
            itemName: item?.name || req.itemId
          }
        })
      } catch (_err) {
        toolRequests.value = []
      }
    }

    const respondToolRequest = async (requestId: string, status: string, notes = '') => {
      if (props.isAnalyst) return
      await apiFetch(`/warehouse/task-tool-requests/${encodeURIComponent(requestId)}/respond`, {
        method: 'POST',
        body: JSON.stringify({ status, notes })
      })
      await refreshToolRequests()
    }

    const refreshAll = async () => {
      await Promise.allSettled([warehouseStore.refresh(), projectsStore.refresh(), refreshReservations(), refreshDamages(), refreshUserRequests(), refreshToolRequests()])
    }

    const viewItem = (id: string) => {
      const item = items.value.find((entry) => entry.id === id)
      if (!item) return
      uiStore.toast(`${item.name} — Qtd: ${item.quantityTotal} | Disp: ${item.availableQuantity} | ${item.conditionStatus || 'sem estado'}`, 'info', 6000)
    }

    const toggleFilterPanel = () => {
      showFilterPanel.value = !showFilterPanel.value
    }

    const openStock = () => {
      tab.value = 'estoque'
      router.push('/almoxarifado?tab=estoque')
      refreshAll().catch(() => {
        // ignore refresh error
      })
    }

    const openRequests = () => {
      tab.value = 'solicitacoes'
      router.push('/almoxarifado?tab=solicitacoes')
      refreshAll().catch(() => {
        // ignore refresh error
      })
    }

    const openPlanejamento = async () => {
      tab.value = 'planejamento'
      router.push('/almoxarifado?tab=planejamento')
      isLoadingReservations.value = true
      try {
        const data = await apiFetch<Record<string, Array<{ toolId: string; toolName: string; quantity: number; taskId: string; taskTitle: string; startDate: string; endDate: string }>>>('/warehouse/reservations-by-date')
        reservationsByDate.value = data || {}
      } catch (_err) {
        reservationsByDate.value = {}
      } finally {
        isLoadingReservations.value = false
      }
    }

    const openDamages = () => {
      router.push('/almoxarifado/avarias')
      refreshAll().catch(() => {
        // ignore refresh error
      })
    }
    const openDamageDetail = (id: string) => {
      router.push(`/almoxarifado/avarias/detalhe/${encodeURIComponent(id)}`)
    }

    const openProvideForm = () => {
      if (props.isAnalyst) return
      router.push('/almoxarifado/fornecer')
    }

    const openAddItemForm = (editId = '') => {
      if (props.isAnalyst) return
      if (editId) {
        router.push(`/almoxarifado/adicionar-item?edit=${encodeURIComponent(editId)}`)
        return
      }
      router.push('/almoxarifado/adicionar-item')
    }

    const openTransferItemForm = () => {
      if (props.isAnalyst) return
      router.push('/almoxarifado/transferir-item')
    }

    const openTransferArea = (itemId: string, currentLocation: string) => {
      if (props.isAnalyst) return
      transferAreaItemId.value = itemId
      const project = findProjectByLocation(currentLocation)
      transferAreaProjectId.value = project ? project.id : ''
    }

    const cancelTransferArea = () => {
      transferAreaItemId.value = ''
      transferAreaProjectId.value = ''
    }

    const confirmTransferArea = async (itemId: string) => {
      if (props.isAnalyst) return
      const item = items.value.find((entry) => entry.id === itemId)
      if (!item) return
      await warehouseStore.upsert({
        id: item.id,
        code: item.code,
        name: item.name,
        category: item.category,
        quantityTotal: item.quantityTotal,
        quantityMin: item.quantityMin,
        location: transferAreaProjectId.value,
        conditionStatus: item.conditionStatus,
        unitValue: item.unitValue,
        photoDataUrl: item.photoDataUrl
      })
      cancelTransferArea()
    }

    const reportDamage = async (id: string) => {
      if (props.isAnalyst) return
      router.push(`/almoxarifado/avarias/nova?item=${encodeURIComponent(id)}`)
    }

    const requestStatusLabel = (status: number) => {
      if (status === 0) return 'aguardando aprovacao'
      if (status === 1) return 'aprovado'
      if (status === 2) return 'aguardando confirmacao de fornecimento'
      if (status === 3) return 'fornecido'
      if (status === 4) return 'aguardando devolucao'
      if (status === 5) return 'devolvido'
      return `status-${status}`
    }

    const setUserRequestStatus = async (id: string, status: number) => {
      if (props.isAnalyst) return
      await apiFetch(`/warehouse/user-requests/${encodeURIComponent(id)}/status`, {
        method: 'POST',
        body: JSON.stringify({ status })
      })
      await refreshAll()
    }
    const requestUserReturn = async (id: string) => {
      if (props.isAnalyst) return
      await apiFetch(`/warehouse/user-requests/${encodeURIComponent(id)}/request-return`, {
        method: 'POST',
        body: JSON.stringify({})
      })
      await refreshAll()
    }
    const formatDate = (dateStr: string) => {
      const match = `${dateStr || ''}`.match(/(\d{4})-(\d{2})-(\d{2})/)
      if (!match) return dateStr
      const [, year, month, day] = match
      return `${day}/${month}/${year}`
    }
    const itemPhotoById = (itemId: string) => items.value.find((entry) => entry.id === itemId)?.photoDataUrl || ''

    const itemName = (itemId: string) => items.value.find((entry) => entry.id === itemId)?.name || itemId
    const isStockActive = computed(() => mode.value === 'browse' && tab.value === 'estoque')
    const isRequestsActive = computed(() => mode.value === 'browse' && tab.value === 'solicitacoes')
    const isPlanejamentoActive = computed(() => mode.value === 'browse' && tab.value === 'planejamento')
    const isDamagesActive = computed(() => mode.value === 'damages' || mode.value === 'damage-form' || mode.value === 'damage-detail')
    const isProvideActive = computed(() => mode.value === 'provide')
    const isAddItemActive = computed(() => mode.value === 'add-item')
    const isTransferItemActive = computed(() => mode.value === 'transfer-item')

    watch(
      () => route.query.tab,
      (nextTab) => {
        if (nextTab === 'solicitacoes' || nextTab === 'estoque') {
          tab.value = nextTab
        }
      },
      { immediate: true }
    )

    watch(
      [() => route.path, () => route.query],
      () => {
        refreshAll().catch(() => {
          // ignore route refresh error
        })
      }
    )

    onMounted(() => {
      refreshAll().catch(() => {
        // ignore initial fetch error
      })
    })

    return {
      mode,
      tab,
      reservations,
      userRequests,
      toolRequests,
      items,
      projects,
      showFilterPanel,
      organizeByArea,
      groupedItemsByArea,
      transferAreaItemId,
      transferAreaProjectId,
      filteredDamages,
      showResolvedHistory,
      canResolveDamage,
      isStockActive,
      isRequestsActive,
      isPlanejamentoActive,
      isDamagesActive,
      isProvideActive,
      isAddItemActive,
      isTransferItemActive,
      toggleFilterPanel,
      areaLabel,
      supervisorLabel,
      openStock,
      openRequests,
      openPlanejamento,
      openDamages,
      openDamageDetail,
      openProvideForm,
      openAddItemForm,
      openTransferItemForm,
      openTransferArea,
      cancelTransferArea,
      confirmTransferArea,
      viewItem,
      reportDamage,
      requestUserReturn,
      requestStatusLabel,
      setUserRequestStatus,
      respondToolRequest,
      itemPhotoById,
      itemName,
      reservationsByDate,
      isLoadingReservations,
      formatDate,
      movementHistoryItemId,
      movementHistoryItemName,
      openMovementHistory,
      closeMovementHistory,
      openNfeImport,
      onNfeImportDone
    }
  }
})
</script>

<style scoped lang="scss">
.warehouse-shell { width: 100%; }

/* ── Nav ── */
.wh-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(31,30,26,.1);
}
.wh-nav-group { display: flex; gap: 4px; flex-wrap: wrap; }
.wh-tab {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 8px; border: none; cursor: pointer;
  background: transparent; font-size: 13px; font-weight: 500;
  color: var(--ink-muted, #666);
  transition: background .12s, color .12s;
  &:hover { background: rgba(31,30,26,.05); color: var(--ink, #2c2b27); }
  &.active {
    background: var(--system-navbar, #0f4c81);
    color: var(--system-navbar-text, #fff);
  }
}
.wh-nav-actions { display: flex; gap: 6px; flex-wrap: wrap; }
.wh-action-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 13px; border-radius: 8px; border: 1.5px solid rgba(31,30,26,.15); cursor: pointer;
  background: #fff; font-size: 12px; font-weight: 600; color: var(--ink, #2c2b27);
  transition: border-color .12s, background .12s;
  &:hover { border-color: var(--system-navbar, #0f4c81); background: #f0f5ff; }
  &.active { background: var(--system-navbar, #0f4c81); color: var(--system-navbar-text, #fff); border-color: transparent; }
}

/* ── Section ── */
.section { padding-top: 4px; }
.section-head {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 16px;
}
.section-title { margin: 0; font-size: 18px; font-weight: 800; color: var(--ink, #2c2b27); }

.toggle-btn {
  padding: 6px 14px; border-radius: 7px; border: 1.5px solid rgba(31,30,26,.15);
  background: #fff; cursor: pointer; font-size: 12px; font-weight: 600; color: var(--ink-muted, #666);
  transition: background .12s;
  &:hover { background: rgba(31,30,26,.04); }
}
.toggle-check {
  display: inline-flex; align-items: center; gap: 7px;
  font-size: 13px; font-weight: 500; color: var(--ink-muted, #666); cursor: pointer;
  input { cursor: pointer; }
}

/* ── Empty states ── */
.empty-hint {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; padding: 60px 20px; color: var(--ink-muted, #aaa); text-align: center;
  font-size: 14px;
  svg { opacity: .35; }
}
.empty-hint-sm {
  font-size: 13px; color: var(--ink-muted, #aaa); padding: 10px 0;
}

/* ── Cards grid ── */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}

.item-card {
  border: 1px solid rgba(31,30,26,.1);
  border-radius: 14px;
  overflow: hidden;
  background: var(--card, #fff);
  display: flex;
  flex-direction: column;
  transition: box-shadow .18s, transform .18s;
  &:hover { box-shadow: 0 8px 24px rgba(0,0,0,.09); transform: translateY(-2px); }
}
.damage-clickable { cursor: pointer; }

.card-photo {
  height: 140px; overflow: hidden; background: #f4f4f2; flex-shrink: 0;
}
.card-img {
  width: 100%; height: 100%; object-fit: cover;
  transition: transform .25s;
  .item-card:hover & { transform: scale(1.04); }
}
.card-img-placeholder {
  width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
  color: rgba(31,30,26,.2);
}

.card-body {
  padding: 12px 14px 8px;
  flex: 1;
  display: flex; flex-direction: column; gap: 4px;
}
.card-title { font-size: 14px; font-weight: 700; color: var(--ink, #2c2b27); line-height: 1.3; }
.card-meta { font-size: 12px; color: var(--ink-muted, #888); }

.qty-row { display: flex; gap: 5px; flex-wrap: wrap; margin-top: 4px; }
.qty-badge {
  font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 20px;
  &.qty--ok   { background: #dcfce7; color: #15803d; }
  &.qty--low  { background: #fef2f2; color: #dc2626; }
  &.qty--total { background: #f0f4ff; color: #3b5bdb; }
  &.qty--cond  { background: #fef9c3; color: #854d0e; }
}

.card-footer {
  display: flex; gap: 2px; flex-wrap: wrap;
  padding: 8px 10px; border-top: 1px solid rgba(31,30,26,.07);
}
.card-btn {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 5px 9px; border-radius: 6px; border: none; cursor: pointer;
  background: transparent; color: var(--ink-muted, #666); font-size: 11px; font-weight: 500;
  transition: background .12s, color .12s;
  &:hover { background: rgba(31,30,26,.06); color: var(--ink, #2c2b27); }
  &--warn:hover { background: #fff7ed; color: #c2410c; }
}

/* ── Transfer inline ── */
.transfer-inline {
  padding: 10px 14px 12px;
  border-top: 1px solid rgba(31,30,26,.08);
  display: flex; flex-direction: column; gap: 8px;
  background: #fafafa;
}
.transfer-select {
  width: 100%; padding: 7px 10px; border-radius: 7px;
  border: 1.5px solid rgba(31,30,26,.18); font-size: 13px;
  outline: none;
  &:focus { border-color: var(--system-navbar, #0f4c81); }
}
.transfer-actions { display: flex; gap: 8px; }
.btn-save-sm {
  padding: 6px 14px; border-radius: 6px; border: none; cursor: pointer;
  background: var(--system-navbar, #0f4c81); color: #fff; font-size: 12px; font-weight: 700;
  &:hover { opacity: .88; }
}
.btn-cancel-sm {
  padding: 6px 12px; border-radius: 6px; cursor: pointer;
  background: transparent; border: 1.5px solid rgba(31,30,26,.15); font-size: 12px; font-weight: 600;
  &:hover { background: rgba(31,30,26,.04); }
}

/* ── Area sections ── */
.area-section { margin-bottom: 24px; }
.area-title {
  display: flex; align-items: center; gap: 6px;
  margin: 0 0 12px; font-size: 14px; font-weight: 700; color: var(--ink, #2c2b27);
  svg { opacity: .5; }
}
.area-count {
  margin-left: 4px; background: rgba(31,30,26,.08); border-radius: 20px;
  padding: 1px 8px; font-size: 11px; font-weight: 600; color: var(--ink-muted, #888);
}

/* ── Status chips ── */
.status-chip {
  display: inline-block; font-size: 11px; font-weight: 600;
  padding: 2px 9px; border-radius: 20px; margin-top: 4px;
  &.chip--ok      { background: #dcfce7; color: #15803d; }
  &.chip--warn    { background: #fff7ed; color: #c2410c; }
  &.chip--pending { background: #fef9c3; color: #854d0e; }
  &.chip--info    { background: #e0f2fe; color: #0369a1; }
}

/* ── Requests ── */
.sub-block { margin-bottom: 28px; }
.sub-title { margin: 0 0 12px; font-size: 15px; font-weight: 700; color: var(--ink, #2c2b27); }
.req-list { display: flex; flex-direction: column; gap: 8px; }
.req-card {
  border: 1px solid rgba(31,30,26,.1); border-radius: 10px; padding: 12px 14px;
  background: var(--card, #fff);
  display: flex; align-items: flex-start; justify-content: space-between; gap: 14px;
  flex-wrap: wrap;
}
.req-info { flex: 1; display: flex; flex-direction: column; gap: 3px; }
.req-name { font-size: 14px; font-weight: 600; color: var(--ink, #2c2b27); }
.req-meta { font-size: 12px; color: var(--ink-muted, #888); }
.req-notes { font-style: italic; }
.req-actions { display: flex; gap: 6px; flex-shrink: 0; }
.req-btn {
  padding: 6px 13px; border-radius: 7px; border: 1.5px solid rgba(31,30,26,.15);
  background: #fff; cursor: pointer; font-size: 12px; font-weight: 600; color: var(--ink-muted, #666);
  transition: background .12s, border-color .12s;
  &--ok   { border-color: #bbf7d0; color: #15803d; background: #f0fdf4; &:hover { background: #dcfce7; } }
  &--deny { border-color: #fecaca; color: #dc2626; background: #fef2f2; &:hover { background: #fee2e2; } }
  &:hover { background: rgba(31,30,26,.04); }
}

/* ── Timeline ── */
.reservations-timeline { display: grid; gap: 0; }
.timeline-entry {
  display: grid; grid-template-columns: 130px 1fr; gap: 20px;
  padding: 16px 0; border-bottom: 1px solid rgba(31,30,26,.08);
  &:last-child { border-bottom: none; }
}
.timeline-date { font-weight: 700; font-size: 13px; color: var(--ink, #2c2b27); padding-top: 2px; }
.timeline-tools { display: flex; flex-wrap: wrap; gap: 10px; }
.tool-reservation {
  background: #f8f7f5; border: 1px solid rgba(31,30,26,.1);
  border-radius: 8px; padding: 10px 12px;
  display: flex; flex-direction: column; gap: 4px;
  min-width: 160px;
}
.tool-name { font-weight: 600; font-size: 13px; color: var(--ink, #2c2b27); }
.tool-qty { font-size: 12px; color: #16a34a; font-weight: 600; }
.tool-task { font-size: 11px; color: var(--ink-muted, #888); }

@keyframes spin { to { transform: rotate(360deg); } }

@media (max-width: 600px) {
  .wh-nav { gap: 8px; }
  .cards-grid { grid-template-columns: 1fr; }
  .timeline-entry { grid-template-columns: 1fr; gap: 8px; }
  .req-card { flex-direction: column; }
}
</style>
